var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBitbucketWhite = function SvgBitbucketWhite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.975 7.596H13.2l-.97 5.658h-4L3.509 18.86c.15.13.34.202.538.204h12.535a.616.616 0 0 0 .616-.517z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.23 1.793a.615.615 0 0 0-.615.714l2.613 15.858a.83.83 0 0 0 .28.495c.15.13.34.202.538.204l4.85-5.81h-.68L7.147 7.596h11.827l.831-5.086a.617.617 0 0 0-.615-.714z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBitbucketWhite);
export { ForwardRef as ReactComponent };